import React, { Component } from 'react';

class GeneralFormatter extends Component {
  render() {
    return <div>{this.props.value}</div>;
  }
}

export default GeneralFormatter;
